module.exports = __webpack_public_path__ + "img/Temperus_island_raw.d743f3ac.png";